import { STATS } from "@/data/site";

export default function StatsBand() {
  return (
    <section data-testid="stats-band" className="bg-white border-y border-teh-navy/10">
      <div className="teh-container py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-10 gap-x-6">
          {STATS.map((s, i) => (
            <div key={s.label} className="flex flex-col items-start" data-testid={`stat-${i}`}>
              <div className="font-serif text-5xl md:text-6xl text-teh-navy leading-none">
                {s.value}
              </div>
              <div className="mt-4 h-px w-10 bg-teh-green" />
              <p className="mt-4 text-sm text-teh-muted leading-relaxed max-w-[200px]">
                {s.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
